import { ruRU } from '@mui/material/locale';
import { createTheme } from '@mui/material/styles';

const themeEpicBoom = createTheme(
  {
    palette: {
      mode: 'dark',
      primary: {
        main: '#ff7f24',
      },
      warning: {
        main: '#ff7f24',
      },
      secondary: {
        main: '#272727',
      },
      success: {
        main: '#289672',
      },
      info: {
        main: '#eeeeee',
      },
      white: {
        main: '#fff',
      },
      midnightBlue: {
        main: '#011c40',
        dark: '#021734',
      },
    },
    gradient: {
      allJackpot: {
        main: 'linear-gradient(to left, #393b3c 0%, #393b3c 100%)',
      },
    },
    mixins: {
      toolbar: {
        height: '56px',
      },
    },
    typography: {
      htmlFontSize: 18,
      button: {
        fontWeight: 'bold',
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            '&.no-shadow': {
              boxShadow: 'none',
            },
          },
        },
      },
      MuiTextField: {
        defaultProps: {
          color: 'warning',
          variant: 'filled',
        },
      },
      MuiSkeleton: {
        defaultProps: {
          animation: 'wave',
        },
      },
      MuiFilledInput: {
        defaultProps: {
          disableUnderline: true,
        },
        styleOverrides: {
          root: ({ ownerState, theme }) => ({
            ...(ownerState.disableUnderline && {
              borderRadius: theme.shape.borderRadius,
            }),
          }),
          input: ({ ownerState }) => ({
            ...(ownerState.endAdornment && {
              '&:-webkit-autofill': {
                borderBottomLeftRadius: 'inherit',
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
              },
            }),
          }),
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            '&.no-shadow': {
              boxShadow: 'none',
            },
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: ({ theme }) => ({
            '&.Mui-selected': {
              color: theme.palette.warning.main,
            },
          }),
        },
      },
      MuiTabs: {
        styleOverrides: {
          indicator: ({ theme }) => ({
            backgroundColor: theme.palette.warning.main,
          }),
        },
      },
      MuiMenu: {
        styleOverrides: {
          list: {
            '& > .MuiMenuItem-root:last-child': {
              borderBottom: 'none',
            },
          },
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: {
            margin: '8px',
            width: 'calc(100% - 16px)',
            maxHeight: 'calc(100% - 16px)',
            maxWidth: 'calc(100% - 16px)',
          },
          paperFullScreen: {
            margin: '0',
            width: '100%',
            maxHeight: '100%',
            maxWidth: '100%',
          },
          paperWidthSm: {
            width: '600px',
          },
        },

      },
    },
  },
  ruRU,
);

export default themeEpicBoom;
